import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=4851f482&"
import script from "./ProcessForm.vue?vue&type=script&lang=js&"
export * from "./ProcessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports